var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.link}},[_c('div',{staticClass:"single-team-wrap bg-white text-center border rounded p-4 my-3"},[_c('img',{staticClass:"img-fluid m-auto",attrs:{"src":_vm.imageUrl,"alt":"client image","height":"300","width":"200"}}),_c('div',{staticClass:"team-content"},[_c('h5',{staticClass:"mt-3 pt-3"},[_vm._v(_vm._s(_vm.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }